import LOGO from './logo/logo_symbol.png';
import LOGO_HORIZONTAL from './logo/logo_horizontal.png';

// TODO: REMOVED
import ajm1 from './ajm/profile/1.jpeg';
import ajm2 from './ajm/profile/2.png';
import ajm3 from './ajm/profile/3.jpeg';
import ajm4 from './ajm/profile/4.jpeg';

import ghe1 from './ghe/profile/1.jpg';
import ghe2 from './ghe/profile/2.jpg';
import ghe3 from './ghe/profile/3.jpg';
import ghe4 from './ghe/profile/4.jpg';

import jhs1 from './jhs/profile/1.jpg';
import jhs2 from './jhs/profile/2.jpg';
import jhs3 from './jhs/profile/3.jpg';
import jhs4 from './jhs/profile/4.jpg';

import jj1 from './jj/profile/1.jpg';
import jj2 from './jj/profile/2.jpg';
import jj3 from './jj/profile/3.jpg';
import jj4 from './jj/profile/4.jpg';

import jjh1 from './jjh/profile/1.jpg';
import jjh2 from './jjh/profile/2.jpg';
import jjh3 from './jjh/profile/3.jpg';
import jjh4 from './jjh/profile/4.jpg';

import jns1 from './jns/profile/1.jpg';
import jns2 from './jns/profile/2.jpg';
import jns3 from './jns/profile/3.jpg';
import jns4 from './jns/profile/4.jpg';

import kbb1 from './kbb/profile/1.jpeg';
import kbb2 from './kbb/profile/2.jpeg';
import kbb3 from './kbb/profile/3.jpeg';
import kbb4 from './kbb/profile/4.jpeg';

import lhe1 from './lhe/profile/1.jpg';
import lhe2 from './lhe/profile/2.jpg';
import lhe3 from './lhe/profile/3.jpg';
import lhe4 from './lhe/profile/4.jpg';

import lsb1 from './lsb/profile/1.jpg';
import lsb2 from './lsb/profile/2.jpg';
import lsb3 from './lsb/profile/3.jpg';
import lsb4 from './lsb/profile/4.jpg';

import lsk1 from './lsk/profile/1.png';
import lsk2 from './lsk/profile/2.png';
import lsk3 from './lsk/profile/3.jpeg';
import lsk4 from './lsk/profile/4.png';

const ajmProfile = [ ajm1, ajm2, ajm3, ajm4 ];
const gheProfile = [ ghe1, ghe2, ghe3, ghe4 ];
const jhsProfile = [ jhs1, jhs2, jhs3, jhs4 ];
const jjProfile = [ jj1, jj2, jj3, jj4 ];
const jjhProfile = [ jjh1, jjh2, jjh3, jjh4 ];
const jnsProfile = [ jns1, jns2, jns3, jns4 ];
const kbbProfile = [ kbb1, kbb2, kbb3, kbb4 ];
const lheProfile = [ lhe1, lhe2, lhe3, lhe4 ];
const lsbProfile = [ lsb1, lsb2, lsb3, lsb4 ];
const lskProfile = [ lsk1, lsk2, lsk3, lsk4 ];

export {
  LOGO,
  LOGO_HORIZONTAL,

  // TODO: REMOVED
  ajmProfile,
  gheProfile,
  jhsProfile,
  jjProfile,
  jjhProfile,
  jnsProfile,
  kbbProfile,
  lheProfile,
  lsbProfile,
  lskProfile,
};
